import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import { LIST_ME_GYMS, CHANGE_GYM } from './types';

export const listMeGyms = createRoutine(LIST_ME_GYMS);
export const changeGym = createRoutine(CHANGE_GYM);
export const promisifyChangeGym = promisifyRoutine(changeGym);
